import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import LoginLogo from "../../Components/Assets/images/logo2.png";
import { account } from "../../appwrite";
import { ChevronLeft, Eye, EyeOff } from "lucide-react";
import { useTitle } from "../../hooks/useTitle";

const ChangePassword = () => {
  useTitle("Change Password - TrendBay");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();

  const validatePassword = (pw) =>
    /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(pw);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (newPassword !== confirmNewPassword) {
      setError("New passwords do not match.");
      return;
    }

    if (!validatePassword(newPassword)) {
      setError("Password must have at least 8 characters, 1 uppercase, 1 number & 1 symbol.");
      return;
    }

    setLoading(true);
    try {
      await account.updatePassword(newPassword, currentPassword);
      setMessage("Password updated! Redirecting to login…");
      await account.deleteSession("current");
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      const msg = err?.message || "";
      if (msg.includes("Invalid credentials") || msg.includes("password")) {
        setError("Incorrect current password. Please try again.");
      } else {
        setError("Failed to change password. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <a href="/"><img className="auth-logo" src={LoginLogo} alt="TrendBay" /></a>
        <h1 className="auth-heading">Change Password</h1>
        <p className="auth-sub">Enter your current password and choose a new one.</p>

        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label className="auth-label">Current Password</label>
            <div className="auth-pw-wrap">
              <input
                className="auth-input"
                type={showCurrent ? "text" : "password"}
                placeholder="Current password"
                value={currentPassword}
                onChange={(e) => { setCurrentPassword(e.target.value); setError(""); }}
                required
              />
              <span className="auth-pw-toggle" onClick={() => setShowCurrent((p) => !p)}>
                {showCurrent ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
          </div>

          <div className="auth-field">
            <label className="auth-label">New Password</label>
            <div className="auth-pw-wrap">
              <input
                className="auth-input"
                type={showNew ? "text" : "password"}
                placeholder="New password"
                value={newPassword}
                onChange={(e) => { setNewPassword(e.target.value); setError(""); }}
                required
              />
              <span className="auth-pw-toggle" onClick={() => setShowNew((p) => !p)}>
                {showNew ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
          </div>

          <div className="auth-field">
            <label className="auth-label">Confirm New Password</label>
            <div className="auth-pw-wrap">
              <input
                className="auth-input"
                type={showConfirm ? "text" : "password"}
                placeholder="Confirm new password"
                value={confirmNewPassword}
                onChange={(e) => { setConfirmNewPassword(e.target.value); setError(""); }}
                required
              />
              <span className="auth-pw-toggle" onClick={() => setShowConfirm((p) => !p)}>
                {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
          </div>

          <button type="submit" className="auth-btn-primary" disabled={loading}>
            {loading ? "Updating…" : "Update Password"}
          </button>
        </form>

        <Link to="/account" className="otp-back">
          <ChevronLeft size={15} /> Back to Account
        </Link>
      </div>
    </div>
  );
};

export default ChangePassword;
